/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Form,
  Col,
  Row,
  Input,
  Select,
  Table,
  Button,
  Modal,
} from "antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateModal } from "./create-modal";
import { EditModal } from "./edit-modal";
import { useState } from "react";
import {
  department,
} from "../../../../info-technology-process/data";
import { useSelector } from "../../../../../../store/store";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { Upload, message, Checkbox } from "antd";

import { IMaterialType } from "../../models";
import { HiOutlineTrash } from "react-icons/hi2";
import { UploadOutlined } from "@ant-design/icons";
import {
  getDDMMYYYFormat,
} from "../../../../../../helper/dateTimeHelper";
import { PlanningDepartmentExportService } from "../../../../../../services/planning-department/export-warehouse";
import { getEnv } from "../../../../../../AppConfigs";
import { eContent, formFields1 } from "../../constant/field-names";
import { validatePhoneNumber } from "../../../../../../services/util";
import ExcelJS from "exceljs";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import { getTemplate } from "../../../../../../components/input/arrayData/excel-template";
import moment from "moment";
import { StyledTitle } from "../../../../../../components/styled-antd/Title";
import { StyledButton } from "../../../../../../components/styled-antd";
import { useSoftwares } from "../../../../../../hook";
import { SystemCode, requestStatus } from "../../../../../../constants";
import { getEmployeeDetail } from "../../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";
import { RenderApprover, RenderCreateFormButton, RenderHelper, RenderUnit } from "../../../../human-organization/summary-employee-request/utils/render-helper";
import { PATH } from "../../constant/path";
import _ from "lodash";

export function CreateForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const history = useHistory();
  const [fileList, setFileList] = useState<any[]>([]);
  const { exportFile } = useExcelTemplate();
  const [form] = Form.useForm();
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const { getITLeadITHeadAssignee } = useSoftwares();
  const [departmentValue, setDepartmentValue] = useState("");
  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );

  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      setDepartmentValue(changedValues.eDepartment);

      const selectedDepartment = department.filter(
        (value) => value.value == changedValues.eDepartment
      )[0];

      if (selectedDepartment.id === 2) {
        form.setFieldValue("eUnit", null);
      } else if (selectedDepartment.id === 3) {
        form.setFieldValue("eUnit", null);
      } else if (selectedDepartment.id === 1) {
        form.setFieldValue("eUnit", null);
      } else {
        form.setFieldValue("eUnit", selectedDepartment.id);
      }

      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };



  const columns: ColumnsType<IMaterialType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: IMaterialType, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="flex">
            <EditModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              index={index}
            />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                if ((dataSource.length - 1) % 10 == 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES) {
                    setCurrentPage(currentPage - 1);
                  }
                }

                setDataSource((prev: any) => {
                  return prev.filter(
                    (value: any, indexValue: number) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IMaterialType, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    {
      title: "Tên vật tư/ hàng hóa",
      dataIndex: eContent.productName,
      key: eContent.productName,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram,
    },
    {
      title: "Số lượng đề nghị",
      dataIndex: eContent.requestedQuantity,
      key: eContent.requestedQuantity,
    },
    {
      title: "Số lượng tồn tại đơn vị",
      dataIndex: eContent.inventoryQuantity,
      key: eContent.inventoryQuantity,
    },
    {
      title: "Thời gian sử dụng",
      dataIndex: eContent.productLifetime,
      key: eContent.productLifetime,

      render: (value: any, record: IMaterialType, index: number) => {
        return <>{getDDMMYYYFormat(value)}</>;
      },
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
    {
      title: "Số lượng phê duyệt",
      dataIndex: eContent.approvedQuantity,
      key: eContent.approvedQuantity,
      render: (value: any, record: IMaterialType, index: number) => {
        return <></>;
      },
    },
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          if (!Array.isArray(item) || item.length != 6) {
            CreateNotification({
              title: "Import file thất bại",
              body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
              icon: "/icons/error.png",
            });
            return;
          }

          dataSource.push({
            [eContent.productName]: item[0],
            [eContent.Dram]: item[1],
            [eContent.requestedQuantity]: item[2],
            [eContent.inventoryQuantity]: item[3],
            [eContent.productLifetime]: moment(item[4], "DD/MM/YYYY"),
            [eContent.note]: item[5],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);

        setFileList([...fileList, file]);
      };

      return false;
    },
    showUploadList: false,
    fileList,
  };

  const props2: UploadProps = {
    name: "files",
    multiple: true,
    action: "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file",

    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        message.success(`${info.file.name} upload thành công`);
      } else if (status === "error") {
        message.error(`${info.file.name} upload thất bại`);
      }
    },

    onPreview(file: any) {
      window.open(file?.response?.data?.[0]);
    },
  };

  const siteUrl = getEnv(
    "REACT_APP_APPROVER_EXPORT_WAREHOUSE_PLANNING_DEPARTMENT"
  );

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập các thông tin yêu cầu`,
        icon: "/icons/error.png",
      });
      return;
    }

    let initFields: any = {
      Title: "Thu hồi công cụ dụng cụ",
      eDepartment: values.eDepartment,
      eUnit: values.eUnit,

      eRequestStatus: requestStatus.submitted,

      eApprovedStatus: requestStatus.submitted,
      eApprovedByITLeadStatus: requestStatus.submitted,

      eApprovedBy:
        values.pickedUser && values.pickedUser != ""
          ? values.pickedUser.split("|")[0].toLowerCase()
          : values.eApprovedBy.split("|")[0].toLowerCase(),

      eApprovedByITLead: getITLeadITHeadAssignee(
        SystemCode.EWR
      ).eAssignee.split("|")[0],
    };

    try {
      const resp = await PlanningDepartmentExportService.addNewRequest({
        fields: {
          ...initFields,

          ePhoneNumber: values.ePhoneNumber,
          eReason: values.eReason,
          eContent: JSON.stringify(dataSource),
          eTypeExportWarehouse:
            values.eTypeExportWarehouse === "Khác"
              ? values.eOtherTypeExportWarehouse
              : values.eTypeExportWarehouse,

          eFileContent: JSON.stringify(values?.eFiles?.fileList || []),
        },
      });

      sendEmail(
        resp,
        "EWRA",
        `${
          values.pickedUser && values.pickedUser != ""
            ? values.pickedUser.split("|")[0].toLowerCase()
            : values.eApprovedBy.split("|")[0].toLowerCase()
        }|${
          getEmployeeDetail(
            values.pickedUser && values.pickedUser != ""
              ? values.pickedUser.split("|")[0].toLowerCase()
              : values.eApprovedBy.split("|")[0].toLowerCase(),
            employees,
            softwares
          )?.[0]?.Title
        }`,
        mailtemplates,
        "",
        siteUrl,
        "",
        true
      );

      CreateNotification({
        title: "Thành công",
        body: `Tạo phiếu yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(Routes.procedureExportWarehouse.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Tạo phiếu yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.procedureExportWarehouse.path);
    }
  };

  const downLoad = async () => {
    await exportFile(getTemplate("export-warehouse"));
  };

  const [eTypeExportWarehouse, setETypeExportWarehouse] = useState("");

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES)
        setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter(
      (value, index) => !listDelete.includes(index)
    );
    setDataSource(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <>
      <Form
        onFinish={onFinish}
        size="large"
        form={form}
        onValuesChange={onValuesChange}
      >
        <Row gutter={[32, 0]}>
          <RenderHelper fields={formFields1} mode="create" />
          <RenderUnit
            department={departmentValue}
            form={form}
            span={12}
            mode="create"
          />

          <Col span={12}>
            <StyledTitle level={5}>
              Lý do <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="eReason"
              rules={[{ required: true, message: "Nhập lí do" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>
              Đề nghị xuất kho <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="eTypeExportWarehouse"
              rules={[{ required: true, message: "Chọn đề nghị xuất kho" }]}
            >
              <Select
                options={[
                  {
                    value: "All",
                    label: "All",
                  },
                  {
                    value: "Văn phòng phẩm",
                    label: "Văn phòng phẩm",
                  },
                  {
                    value: "Công cụ dụng cụ",
                    label: "Công cụ dụng cụ",
                  },
                  {
                    value: "Nguyên vật liệu",
                    label: "Nguyên vật liệu",
                  },
                  {
                    value: "Trang phục/BHLĐ",
                    label: "Trang phục/BHLĐ",
                  },
                  {
                    value: "Thiết bị/TTB",
                    label: "Thiết bị/TTB",
                  },
                  {
                    value: "Vật tư VSMB",
                    label: "Vật tư VSMB",
                  },
                  {
                    value: "Khác",
                    label: "Khác",
                  },
                ]}
                onChange={(value) => {
                  setETypeExportWarehouse(value);
                }}
              />
            </Form.Item>
          </Col>

          {eTypeExportWarehouse === "Khác" && (
            <Col span={24}>
              <StyledTitle level={5}>
                Khác (Ghi cụ thể) <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name="eOtherTypeExportWarehouse"
                rules={[{ required: true, message: "Nhập số điện thoại" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <StyledTitle level={5}>
              Số điện thoại <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="ePhoneNumber"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (validatePhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Số điện thoại không hợp lệ.")
                    );
                  },
                }),
              ]}
            >
              <Input className="font-weight-normal" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>Đính kèm</StyledTitle>
            <Form.Item name="eFiles">
              <Upload {...props2}>
                <Button className="mx-3 ">
                  <UploadOutlined rev="data" />
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <StyledTitle level={5}>
              Chi tiết <span className="text-danger">(*)</span>
            </StyledTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <CreateModal
              dataSource={dataSource}
              setDataSource={setDataSource}
            />
          </Col>

          <Col>
            {!isMultiDelete && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => setIsMultiDelete(true)}
              >
                Chọn nhiều để xóa
              </StyledButton>
            )}

            {isMultiDelete && (
              <StyledButton
                className="ml-3"
                bgColor="green"
                onClick={() => {
                  setIsMultiDelete(false);
                  setListDelete([]);
                }}
              >
                Quay lại
              </StyledButton>
            )}

            {listDelete.length != 0 && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm();
                }}
              >
                Xóa dữ liệu đã chọn
              </StyledButton>
            )}
          </Col>

          <Col>
            <Upload {...props}>
              <StyledButton bgColor="blue" className="mx-3 ">
                Tải biểu mẫu
              </StyledButton>
            </Upload>
          </Col>

          <Col>
            <div className="mt-1">
              <a href="#" className="text-primary" onClick={downLoad}>
                Download biểu mẫu tại đây
              </a>
            </div>
          </Col>
        </Row>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
          scroll={{
            x: "100vh",
          }}
        />

        <Row gutter={[32, 0]}>
          <RenderApprover department={departmentValue} form={form} />
          <RenderCreateFormButton homePath={PATH.HOME} />
        </Row>
      </Form>
    </>
  );
}
